import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("solo-landing-page-gallery", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("solo-landing-page-gallery"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        stylable: ["background-color"],
      },
    },
  });

  BlockManager.add("solo-landing-page-gallery", {
    ...config,
    label: "Gallery",
    content: template,
  });
}
